/* „Twoje tagi" — the tag boards' `F4-zarzadzanie`: the head with its glyph and „N z 200", the
 * `.trow` rows, the `.ib` squares, the rename row and its `.warn`. 10 October 2026.
 *
 * The shell is `shared/ui/dialogSurface` at its default 520px, which is the board's own width.
 * Every text leaf states its line-height. The counts are `--text-2` rather than the board's
 * `--text-3` — deviations register entry 18's call for every small figure on this screen. */

.head {
  display: flex;
  gap: var(--space-2);
  align-items: center;
}

.glyph {
  flex: none;
  width: 16px;
  height: 16px;
  color: var(--text-2);
}

.total {
  margin-left: var(--space-10px);
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  line-height: var(--lh-note);
  color: var(--text-2);
  font-variant-numeric: tabular-nums;
}

/* The close square is pushed to the end of the line, whatever stands before it. */
.head > :last-child {
  margin-left: auto;
}

.rows {
  display: flex;
  flex-direction: column;
  margin: var(--space-0);
  padding: var(--space-0);
  list-style: none;
}

.row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 70px 64px;
  gap: var(--space-10px);
  align-items: center;
  height: 44px;
  padding: var(--space-0) var(--space-1);
  border-bottom: var(--border-hairline) solid var(--border);
}

.row:last-child {
  border-bottom: none;
}

.label {
  min-width: 0;
  overflow: hidden;
  font-size: var(--fs-note);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  color: var(--text);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.count {
  font-size: var(--fs-caption);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  color: var(--text-2);
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.acts {
  display: flex;
  gap: var(--space-1);
  justify-content: flex-end;
}

.iconAct {
  display: inline-grid;
  place-items: center;
  width: 26px;
  height: 26px;
  padding: var(--space-0);
  color: var(--text-2);
  background: transparent;
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-7px);
  cursor: pointer;
}

.iconAct:focus-visible {
  outline: var(--border-focus) solid var(--text);
  outline-offset: var(--space-1px);
}

.iconAct:hover:not([aria-disabled='true']) {
  color: var(--text);
}

.iconAct[aria-disabled='true'] {
  cursor: default;
}

.iconGlyph {
  width: 12px;
  height: 12px;
}

/* The row in rename: the field, the merge warning when there is one, and the two answers. */
.renameRow {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-1);
  border-bottom: var(--border-hairline) solid var(--border);
}

.renameRow:last-child {
  border-bottom: none;
}

.warn {
  margin: var(--space-0);
  padding: var(--space-9px) var(--space-11px);
  font-size: var(--fs-micro);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-note);
  color: var(--text-2);
  background: var(--bg-inset);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-sm);
}

.renameActs {
  display: flex;
  gap: var(--space-2);
  justify-content: flex-end;
}

/* The board's `.b.ink`: the ink fill at the dialog buttons' own geometry. */
.save {
  height: var(--h-control);
  padding: var(--space-0) var(--space-4);
  font-size: var(--fs-label);
  font-weight: var(--fw-bold);
  letter-spacing: var(--ls-heading);
  border-radius: var(--r-button);
}

.skelLabel {
  width: 40%;
  height: 12px;
}

.notice {
  margin: var(--space-0);
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-note);
  color: var(--text);
}
